import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Container, Card } from 'react-bootstrap';
import MessageBoard from './MessageBoard';


const Home = () => {
  const { userDetails, refreshUserDetails } = useAuth();

  useEffect(() => {
    refreshUserDetails();
  }, [refreshUserDetails]);

  if (!userDetails) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      {userDetails.userType === 'employer' && (
        <Card className="mb-4">
          <Card.Header className="bg-white">
            <h5 className="mb-0">Workspace Information</h5>
          </Card.Header>
          <Card.Body>
            <div className="d-flex align-items-center gap-2">
              <span>Share this code with your employees:</span>
              <code className="px-3 py-2 bg-light rounded border">
                {userDetails.communityCode}
              </code>
            </div>
            <Card.Text className="text-muted mt-2">
              Employees can use this code to join your workspace during sign up.
            </Card.Text>
          </Card.Body>
        </Card>
      )}

      {userDetails.userType === 'employee' && (
        <Card className="mb-4">
          <Card.Header className="bg-white">
            <h5 className="mb-0">Workspace Status</h5>
          </Card.Header>
          <Card.Body>
            <p className="mb-2">You're connected to {userDetails.workspaceName}</p>
            {/* <p className="text-muted small">
              Workspace Code: {userDetails.communityCode}
            </p> */}
          </Card.Body>
        </Card>
      )}

      <MessageBoard />
    </Container>
  );
};

export default Home;